import { CircularProgress, Stack } from '@mui/material'

import { MainLayout } from '@/layouts/MainLayout'
import gssp from '@/utils/gssp'

const CaraxWallet = () => {
  return (
    <MainLayout hasNautilus={true}>
      <Stack
        alignItems="center"
        justifyContent="center"
        position="fixed"
        top={0}
        right={0}
        bottom={0}
        left={0}
        zIndex={999999999}
        bgcolor="rgba(0, 0, 0, 0.3)"
        style={{ userSelect: 'none' }}
        className="routing-spinner-wrap"
      >
        <CircularProgress size="4rem" data-testid="browser-loading" />
      </Stack>
    </MainLayout>
  )
}

export const getServerSideProps = gssp(async (context, fetcher) => {
  if (context.query?.url) {
    return {
      redirect: {
        destination: `demonwallet://url?dapp=${context.query?.url}`,
        permanent: true,
      },
    }
  }
})

export default CaraxWallet
